import { Route, Redirect} from 'react-router-dom';
import React, {Suspense, Fragment} from 'react';
import { withAuth } from '@okta/okta-react';
import {
    ToastContainer,
} from 'react-toastify';
import MainPage from '../../Pages/supplier/LandingPage';



const AppMain = (auth) => {
    if (JSON.parse(localStorage.getItem('okta-token-storage')).idToken && JSON.parse(localStorage.getItem('okta-token-storage')).idToken.claims) {
    return (
        <Fragment>

            {/* Dashboards */}

            <Suspense fallback={
                <div className="loader-container">
                    <div className="loader-container-inner">
                        <h6 className="mt-3">
                            Please wait while we load all the Dashboards examples
                            <small>Because this is a demonstration, we load at once all the Dashboards examples. This wouldn't happen in a real live app!</small>
                        </h6>
                    </div>
                </div>
            }>
                <Route path="pages/supplier" component={MainPage}/>
            </Suspense>

            <Route exact path="/" render={() => (
                    <Redirect to="/supplier/LandingPage"/>
                )}/>
            <ToastContainer/>
           
        </Fragment>
    )
            } else {
                
                auth.auth.logout('/');
                return (
                        null
                )
                
            }
};

export default withAuth(AppMain);
